<script lang="ts">
import { navigate, useLocation } from "svelte-navigator";
import { Alert, Button, Col, FormGroup, Icon, Input, InputGroup, Label, Modal, Row } from "sveltestrap";
import { authService } from "../services";
import { startSession, isLoggedIn } from "../services/session";
import { GoogleAuth, FacebookAuth } from '@beyonk/svelte-social-auth';
import { onMount } from "svelte";
import type { Coords } from "../interfaces";
import Footer from "../components/Footer.svelte";

    let showLoginError = false;
    let showLegalError = false
    let acceptLegalText = false;
    let showAlertCoords = false;
    let contactEmail: string = undefined
    let open = false;
    let sendEmail = false;
    let accessWithEmail = false;
    let coords: Coords;

    const location = useLocation();
    const toggle = () => (open = !open);
    
    onMount(() => {
        if (isLoggedIn()) {
            navigate('/');
        }


        navigator.geolocation.getCurrentPosition(successLocation, errorLocation, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        });
    })
    
    function successLocation(pos) {
        coords = {
            lon : pos.coords.longitude,
            lat : pos.coords.latitude
        }

        console.log(coords);
        showAlertCoords = false;
    };

    function errorLocation(err) {
        console.warn('ERROR(' + err.code + '): ' + err.message);

        showAlertCoords = true;
    };
 

    async function login(name, email) {
        const accessToken = await authService.login(name, email);   
        await startSession(accessToken);
        navigate('/');
    }

    function onFacebookAuthSuccess(event){

        if (!acceptLegalText) {
            showLegalError = true;
            return;
        }

        if (event.detail && event.detail.accessToken) {
            window.FB.api('/me?fields=id,name,email', function(response) {
                login(response.name, response.email) 
            });
        }
    }

    function onGoogleAuthSuccess(event){

        if (!acceptLegalText) {
            showLegalError = true;
            return;
        }
        
        if (event.returnValue) {
            if (event.returnValue) {                
                const profile = event.detail.user.getBasicProfile();
                login(profile.getName(), profile.getEmail());
            }  
        }
    }

    async function sendCredential(){
        if (contactEmail == undefined) return;
            
        sendEmail = await authService.sendEmailToken(contactEmail);
    }


</script>



<style lang="scss">

    .alert-coords{
        min-height: 40px;
        width: 100%;
        background-color: #FFDF2C;
        color: #0E3CA5;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center !important;
    }

    .body-html {
        position: relative;
        // height: 100%;
        width: 100vw;
        display: flex;
        align-items: center;
        flex-direction: column;
        max-width: 450px;
        margin: auto;
    }

    .icon-buenavista{
        width: 100%;
        background-color: #0E3CA5;
        color: #fff;
        padding: 25px 30px 25px 30px;
    }

    .login-blue{
        width: 100%;
        background-color: #BAD9FF;
        color: #0E3CA5;
        padding: 25px 30px 25px 30px;
    }

    .form-floating{
        width: 100%;
        // max-width: 275px;
        margin: auto;
        position: relative;

        h1{
            font-size: 20px !important;
            margin-top: 5px;
        }

        .phantom{
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }

        :global(button){
            min-height: 50px;
            border-radius: 5px !important;
            font-weight: bold !important;
        }
        :global(span){
            display: none;
        }
        :global(.facebook-auth){
            width: 110px;
            height: 110px;
            background-color: #fff !important;
            background-image: url('/img/face_icon.png');
            background-size: 70%;
            background-repeat: no-repeat;
            background-position: center;
            
            :global(img){
                display: none;
            }

            &::after{
                content: '';
                color: white !important;
                margin-left: 5px;
            }
        }

        :global(.google-auth){
            width: 110px;
            height: 110px;
            background-color: #fff !important;
            background-image: url('/img/gmail_icon.png');
            background-size: 70%;
            background-repeat: no-repeat;
            background-position: center;

            :global(img){
                display: none;
            }

            &::after{
                content: '';
                color: white !important;
                margin-left: 5px;
            }
        }

   
    }

    .legal-condition{
        margin: 0px !important;

        :global(#text-legal-button){
            color: #0E3CA5;
            font-family: 'PT Sans', sans-serif !important;
            font-weight: bold;
            font-style: italic;
            text-decoration: none;
        }
    }

    :global(#access-button){
        display: block;
        width: 100%;
        height: 50px;
        margin-top: 15px;
        font-weight: bold;
        font-size: 20px;
        color: #0E3CA5;
        border-color: #fff;
    }

    :global(#button-modal-legal){
        display: block;
        width: 100%;
        height: 50px;
        margin-top: 15px;
        font-weight: bold;
        font-size: 20px;
        color: #fff;
        background-color: #0E3CA5;
        border-color: #0E3CA5;
    }



</style>


<div class="body-html">
    {#if showAlertCoords}
        <div class="alert-coords">
            <span><Icon name="compass"/> Activa la localización para acceder</span>
        </div>
    {/if}

    <div class="row icon-buenavista">
        <div class="col-12">
            <img src="/img/BuenavistaEscudo.png" alt="">
        </div>
        <div class="col-12 mt-4">
            <h1>Te damos la bienvenida a la Zona Azul de Buenavista del Norte</h1>
            <p>Puedes registrar el aparcamiento desde esta WebApp o señalizarlo mediante un aviso.</p>
        </div>
    </div>

    {#if !showAlertCoords}
        <div class="row text-center login-blue">
            <div class="col-12">
                <div class="text-center">                
                    <div class="form-floating"> 
                        {#if !acceptLegalText}
                            <div class="phantom" on:click={toggle}></div>
                        {/if}
                        <!-- <div class="row">
                            <div class="col-6">
                                <GoogleAuth clientId="355517175834-cpjaht2n3453fmahr0fllmaf0nhehg66.apps.googleusercontent.com" on:auth-success={onGoogleAuthSuccess} />
                                <h1>Gmail</h1>
                            </div>
                            <div class="col-6">
                                <FacebookAuth appId="708371986883142" on:auth-success={onFacebookAuthSuccess}/>
                                <h1>Facebook</h1>
                            </div>
                        </div> -->

                        <FormGroup>
                            {#if !accessWithEmail || (accessWithEmail && !acceptLegalText)}
                                <Button color="primary" outline id="access-button" on:click={() => accessWithEmail = true}>Acceda con su email</Button>
                            {:else if sendEmail}
                                <div class="mt-4">
                                    <h1>Compruebe su bandeja de entrada</h1>
                                </div>
                            
                            {:else}
                                <InputGroup class="mt-4">
                                    <Input
                                        class="input-group-rd"
                                        type="tel"
                                        id="introPlate"
                                        placeholder="Introduzca su email"
                                        bind:value={contactEmail}
                                    />
                                    <Button color=primary type="button" on:click={sendCredential} disabled={showAlertCoords}>Enviar</Button>
                                </InputGroup>
                            {/if}
                            
                    
                        </FormGroup>
                    </div>
                    <div class="legal-condition">
                        <Row>
                            <Col class="d-flex align-items-center" xs="12"> 
                                <input class="form-check" type="checkbox"  bind:checked={acceptLegalText}>
                                <Button color="link" id="text-legal-button" on:click={toggle}>Acepto las condiciones de privacidad</Button>
                            </Col>
                        </Row>
                
                    </div>


                    {#if showLoginError}
                        <Alert>
                            Ha ocurrido un error
                        </Alert>
                    {/if}

                    {#if showLegalError && !acceptLegalText}
                        <Alert>
                            Debe aceptar las condiciones legales, para poder acceder a la votación
                        </Alert>
                    {/if}


                    <!-- <div class="col-12 p-0">
                        <div class="box-logo">
                            <img src="/img/LaOrotava.png" alt="">
                        </div>
                    </div> -->

                </div>
        
            </div>
        </div>
    {/if}

    <Footer/>




    <Modal class="modal-dialog-centered modal-dialog-scrollable" body header="" isOpen={open} {toggle} >
        <Col>
            <div class="third-tittle">
                <span><strong>Texto Legal</strong></span> 
                <br><br>
                <span>Conforme a lo previsto en la Ley Orgánica 15/99 de 13 de diciembre, de protección de datos de carácter personal, ponemos en conocimiento que los datos extraídos de esta aplicación serán destinados única y exclusivamente para la finalidad objeto de la misma, formando parte de un fichero informático cuyo responsable es el Ayuntamiento de Buenavista del Norte, a quien podrá dirigirse para hacer uso de los derechos que le confiere la mencionada Ley Orgánica.</span>
            </div>
         </Col>
        <Col class="text-center mt-4">
            <div class="d-grid gap-2">
                <Button id="button-modal-legal" color="danger" on:click={() => {
                    open = false;
                    acceptLegalText = true;
                    accessWithEmail = true;
                }}> <span class="third-tittle"><strong>Aceptar</strong></span>
                </Button>
            </div>
        </Col>
    </Modal>
</div>
